import { numbersOnly } from '../validacoes'

export const getViaCep = async (cep) => {
  const cepFormatado = cep ? numbersOnly(cep) : ''

  if (cepFormatado.length === 8) {
    try {
      const response = await fetch(
        `https://viacep.com.br/ws/${cepFormatado}/json/`,
      )

      const result = await response.json()
      return result
    } catch (error) {
      console.error(error.message)
    }

    // return await response.json()
  }
}
